import styled from 'styled-components'

import LiveSelect from 'live/components/forms/ui/select'

export const PaginationContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;

    .form-group {
        margin-bottom: 0;
    }
`

export const SelectLimitPagination = styled.div`
    width: 145px;
    margin-right: 24px;
    .Select-menu {
        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: var(--gray-600);
            border-radius: 10px;
        }
    }
`

export const SelectEdit = styled(LiveSelect)`
    .Select-control {
        /* position: relative; */

        .Select-input :focus {
            /* position: relative; */
        }
        .Select-value {
            /* position: relative; */
        }
    }

    .Select-menu-outer {
        .Select-menu {
            .Select-option {
                /* position: relative; */
            }
        }
    }
    .Select-placeholder {
        /* position: relative; */
    }
`

export const ListButtonsPagination = styled.ul`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0;

    li + li {
        margin-left: 5px;
    }

    button {
        border: none;
        background: transparent;
        color: ${({ theme }) => theme['gray-800']};
        font-size: 13px;
        font-weight: 400;
    }

    .active-page {
        background: transparent;
        color: ${({ theme }) => theme['blue-500']};
        font-weight: 600;
    }

    .active-page:focus {
        outline: none;
    }

    .reticence {
        display: flex;
        flex-direction: row;
        width: 15px;
        height: 3px;
        justify-content: space-between;
        margin: 0 8px;
    }

    .circle {
        width: 3px;
        height: 3px;
        background: ${({ theme }) => theme['gray-300']};
        border-radius: 3px;
    }

    .live-select {
        margin: 0;
        width: 144px;
        margin-left: 20px;
        color: ${({ theme }) => theme['gray-0']};

        #react-select-2--value-item {
            color: ${({ theme }) => theme['gray-0']};
        }
    }
`
